import { signal } from '@angular/core';
import { parseAgrEnvironment } from '@next/core-lib/environment';

import { environment } from '../environments/environment';
import type { Environment } from '../environments/environment.model';

export const loadedConfig = signal<Environment>(environment);

export const setupRuntimeConfig = async () => {
  try {
    const response = await globalThis.fetch('/assets/config.json');
    if (response.ok) {
      const config = await response.json();
      if (config && Object.keys(config).length > 0) {
        loadedConfig.set({
          ...environment,
          ...parseAgrEnvironment(config),
        } as Environment);
      }
    }
  } catch (error) {
    console.warn('Failed to load runtime environment variables', error);
  }
};
